import {
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_SEAT,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import getSeatingMapObjectLabel from '%paysera_seat_selection/js/seatSelection/services/getSeatingMapObjectLabel';
import Translator from '%app/js/common/services/translator';

function buildSeatingLabels(seatingModel) {
    if (!seatingModel) {
        return [null, null];
    }

    const primaryParts = [];
    const secondaryParts = [];

    if (seatingModel.objectType === OBJECT_TYPE_SEAT) {
        if (seatingModel.row !== null) {
            primaryParts.push(Translator.trans('seat_selection_integration.cart.item_prefix.sector'));
            primaryParts.push(seatingModel.row.sector.label.text);

            secondaryParts.push(Translator.trans('seat_selection_integration.cart.item_prefix.row'));
            secondaryParts.push(getSeatingMapObjectLabel(seatingModel.row)?.text);
            secondaryParts.push(Translator.trans('seat_selection_integration.cart.item_prefix.seat'));
            secondaryParts.push(seatingModel.label.text);
        }
        if (seatingModel.roundTable !== null) {
            primaryParts.push(Translator.trans('seat_selection_integration.cart.item_prefix.round_table'));
            primaryParts.push(seatingModel.roundTable.label.text);

            secondaryParts.push(Translator.trans('seat_selection_integration.cart.item_prefix.seat'));
            secondaryParts.push(seatingModel.label.text);
        }
        if (seatingModel.rectangleTable !== null) {
            primaryParts.push(Translator.trans('seat_selection_integration.cart.item_prefix.rectangle_table'));
            primaryParts.push(seatingModel.rectangleTable.label.text);

            secondaryParts.push(Translator.trans('seat_selection_integration.cart.item_prefix.seat'));
            secondaryParts.push(seatingModel.label.text);
        }
    }
    if (seatingModel.objectType === OBJECT_TYPE_GENERAL_ADMISSION) {
        primaryParts.push(Translator.trans('seat_selection_integration.cart.item_prefix.general_admission'));
        primaryParts.push(seatingModel.label.text);
    }

    return [
        primaryParts.join(' '),
        secondaryParts.join(' '),
    ];
}

export default buildSeatingLabels;
